module.exports = __webpack_public_path__ + "img/hiking.2bf2eabc.svg";